import { Close } from '@mui/icons-material';
import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const CreateStockModal = ({ open, onClose, onCrear, allTarifas, loading }) => {

  const [detalleStock, setDetalleStock] = useState("");
  const [ingresos, setIngresos] = useState("");
  const [tarifaSeleccionada, setTarifaSeleccionada] = useState(null);

  const resetForm = () => {
    setDetalleStock("");
    setIngresos("");
    setTarifaSeleccionada(null);
  };

  const handleSubmit = () => {
    if (!ingresos || !tarifaSeleccionada) return;
    onCrear({
      detalle: detalleStock,
      idtarifa: tarifaSeleccionada.id,
      ingresos: parseInt(ingresos),
    });

    resetForm();
  };

  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}
      disableEscapeKeyDown
      maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062" }}>
            Cargar stock
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 0, color: "#0b0062" }}>Tarifa<span style={{ color: "red" }}>*</span></Typography>
        <Autocomplete
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& .MuiInputBase-input': {
              fontFamily: "Bricolage Grotesque",
            },
            '& label.Mui-focused': {
              color: '#5656FF',
              fontFamily: "Bricolage Grotesque"
            },
            '& .MuiOutlinedInput-root': {
              minHeight: "40px",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            },
            '& .MuiAutocomplete-inputRoot': {
              fontFamily: "Bricolage Grotesque",
              minHeight: "40px",
              paddingTop: "0px !important",
              paddingBottom: "0px !important",
            },
            '& .MuiAutocomplete-input': {
              fontFamily: "Bricolage Grotesque",
            }
          }}
          options={allTarifas || []}
          getOptionLabel={t => `${t.concepto} - $${t.precio}`}
          value={tarifaSeleccionada}
          onChange={(_, val) => setTarifaSeleccionada(val)}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <span style={{
                  display: "inline-block",
                  width: 16,
                  height: 16,
                  borderRadius: 3,
                  background: (() => {
                    try {
                      const c = JSON.parse(option.color);
                      return `rgba(${c.r},${c.g},${c.b},${c.a})`;
                    } catch { return "#eee"; }
                  })(),
                  marginRight: 8
                }} />
                <Typography variant="body2">
                  {option.concepto} - ${option.precio}
                </Typography>
              </Box>
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              /* label="Seleccionar Tarifa" */
              margin="none"
              required
            /* placeholder="Buscar tarifa..." */
            />
          )}
          noOptionsText="No se encontraron tarifas"
        />
        <Typography sx={{ mb: 0, color: "#0b0062" }}>Cantidad de stock <span style={{ color: "red" }}>*</span></Typography>
        <TextField
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& .MuiInputBase-input-MuiOutlinedInput-input': {
              fontFamily: "Bricolage Grotesque",
            },
            '& label.Mui-focused': {
              color: '#5656FF',
              fontFamily: "Bricolage Grotesque"
            },
            '& .MuiOutlinedInput-root': {
              height: "40px",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            }
          }}
          type="number"
          value={ingresos}
          onChange={e => setIngresos(e.target.value)}
          fullWidth
          margin="none"
          required
          inputProps={{ min: 1 }}
          placeholder="Ej: 100"
        />
        <Typography sx={{ mb: 0, color: "#0b0062" }}>Descripción (opcional)</Typography>
        <TextField
          sx={{
            fontFamily: "Bricolage Grotesque",
            mb: 2,
            '& .MuiInputBase-input-MuiOutlinedInput-input': {
              fontFamily: "Bricolage Grotesque",
            },
            '& label.Mui-focused': {
              color: '#5656FF',
              fontFamily: "Bricolage Grotesque"
            },
            '& .MuiOutlinedInput-root': {
              minHeight: "40px",
              '& fieldset': {
                borderColor: '#B2BAC2',
              },
              '&:hover fieldset': {
                borderColor: '#5656ff',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#5656ff',
              },
            }
          }}
          value={detalleStock}
          onChange={e => setDetalleStock(e.target.value)}
          fullWidth
          margin="none"
          multiline
          rows={2}
          /* placeholder="Se usará automáticamente 'Stock inicial' o 'Nuevo ingreso' si se deja vacío" */
          helperText="Se usará automáticamente 'Stock inicial' o 'Nuevo ingreso' si se deja vacío"
        />
      </DialogContent>
      <DialogActions sx={{
        padding: window.innerWidth <= 576 ? "12px" : "0 16px 16px", display: "flex",
        flexWrap: window.innerWidth <= 576 ? "wrap" : "nowrap", gap: "10px"
      }}>
        <Button sx={{
          border: "1px solid #5656FF",
          color: "#5656FF",
          padding: "5px 10px",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: window.innerWidth <= 576 ? "13px" : "14px",
          width: "100%",
        }} onClick={onClose}>Cancelar</Button>
        <Button
          sx={{
            marginLeft: "0 !important",
            backgroundColor: "#5656FF",
            color: "white",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: window.innerWidth <= 576 ? "13px" : "14px",
            width: "100%"
          }}
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || !ingresos || !tarifaSeleccionada}
        >
          {loading ? <CircularProgress size={20} /> : "Crear"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateStockModal;